const { createApp } = Vue
createApp({
    data() {
        return {
            gamePlay: gamePlay,
            productHandles: productHandles,
            blogs: blogs,
            currentQuestionId: 1,
            showResult: false,
            finalProducts: "",
            blog: {},
            userChoices: [],
            currentStep: 1,
            questionClass: "active",
            isTransitioning: false,
            selectedAnswer: null,
            history: [],
            estimatedTotalSteps: 6,
            debug: false,
            finalSport: "",
            productLoadWarnings: [], // NEW: collects human-readable warnings so you can see them in debug mode / UI
        }
    },
    computed: {
        currentQuestion() {
            return this.gamePlay.find((q) => q.id === this.currentQuestionId)
        },
        progressPercentage() {
            if (this.showResult) {
                return 100
            }
            return Math.min((this.currentStep / this.estimatedTotalSteps) * 100, 100)
        },
    },
    async mounted() {
        console.info("Starting Quiz Session")

        this.initDebug()
    },
    methods: {
        initDebug() {
            const urlParams = new URLSearchParams(window.location.search)
            if (urlParams.get("debug") === "true") {
                this.debug = true
                localStorage.setItem("debug", "true")
            }
            const debugMode = localStorage.getItem("debug")
            if (debugMode && debugMode === "true") {
                this.debug = true
            }

            if (urlParams.get("debug") === "false") {
                this.debug = false
                localStorage.removeItem("debug")
            }
        },

        selectAndProceed(answer) {
            if (this.isTransitioning) return

            this.selectedAnswer = answer

            setTimeout(() => {
                this.goToNext()
            }, 200)
        },

        toGID(numericId) {
            return `gid://shopify/Product/${numericId}`
        },

        async getMetafieldFromStorefront(productGID) {
            try {
                const query = `
            query ProductMeta($id: ID!) {
                product(id: $id) {
                    metafield(namespace: "custom", key: "quiz_message") {
                    value
                    }
                }
            }`

                const response = await fetch("https://firstedgesports.com/api/2024-10/graphql.json", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Shopify-Storefront-Access-Token": "4d95efb49947e4c387f512b414f57e75",
                    },
                    body: JSON.stringify({
                        query,
                        variables: { id: productGID },
                    }),
                })

                const result = await response.json()
                return result.data.product?.metafield?.value || ""
            } catch (error) {
                console.error("Error fetching metafield:", error)
                return ""
            }
        },

        // FIX: getProductByHandle now:
        // 1. Checks response.ok BEFORE calling .json() (a 404 page is HTML, not JSON,
        //    so response.json() on a 404 was throwing a confusing parse error before)
        // 2. Logs a clear, specific warning with the exact handle that failed
        // 3. Pushes that warning into productLoadWarnings so it's visible in the UI/console
        // 4. Still returns undefined on failure so getMultipleProducts can filter it out,
        //    but now you'll actually know WHY and WHICH handle failed
        async getProductByHandle(handle) {
            try {
                const response = await fetch(`/products/${handle}.js`)

                if (!response.ok) {
                    const msg = `Product fetch failed (${response.status}) for handle: "${handle}". This handle likely doesn't exist, is unpublished, or is misspelled in productHandles.`
                    console.error(msg)
                    this.productLoadWarnings.push(msg)
                    return undefined
                }

                const product = await response.json()
                const productGID = this.toGID(product.id)
                const metafieldValue = (await this.getMetafieldFromStorefront(productGID)) || ""
                product.finalPrice = "₹ " + (product.price / 100).toFixed(0)
                product.quizMessage = metafieldValue || ""
                return product
            } catch (error) {
                const msg = `Unexpected error fetching product for handle: "${handle}" — ${error.message}`
                console.error(msg)
                this.productLoadWarnings.push(msg)
                return undefined
            }
        },

        selectAnswer(answer) {
            this.selectedAnswer = answer
        },

        async goToNext() {
            if (!this.selectedAnswer || this.isTransitioning) return

            const answer = this.selectedAnswer

            this.history.push({
                questionId: this.currentQuestionId,
                answer: answer,
                choice: {
                    question: this.currentQuestion.Question,
                    answer: answer.response,
                },
                step: this.currentStep,
            })

            const existingIndex = this.userChoices.findIndex((a) => a.id === this.currentQuestion.id)
            const newChoice = {
                question: this.currentQuestion.Question,
                answer: answer.response,
                icon: answer.icon,
                key: this.currentQuestion.key,
                id: this.currentQuestion.id,
            }

            if (existingIndex !== -1) {
                this.userChoices.splice(existingIndex, 1, newChoice)
            } else {
                this.userChoices.push(newChoice)
            }

            if (typeof answer.goTo === "string") {
                this.productLoadWarnings = [] // reset warnings for this run
                this.finalProducts = await this.getfinalProductss(answer.goTo)

                // NEW: if debug mode is on and some products failed to load, log a clear summary
                if (this.debug && this.productLoadWarnings.length > 0) {
                    console.warn(
                        `⚠️ ${this.productLoadWarnings.length} product(s) failed to load out of ${answer.goTo.split(",").length} expected:`,
                        this.productLoadWarnings
                    )
                }

                this.blog = this.blogs.find((v) => v.id == answer.blog)
                this.currentStep = this.estimatedTotalSteps
                this.showResult = true
                this.selectedAnswer = null
                this.finalSport = this.userChoices[0].answer
                return
            }

            this.transitionToNextQuestion(answer.goTo)
        },

        async getMultipleProducts(handles) {
            try {
                const promises = handles.map((handle) => this.getProductByHandle(handle))
                const products = await Promise.all(promises)

                return products.filter((product) => product != null)
            } catch (error) {
                console.error("Error fetching multiple products:", error)
                return []
            }
        },

        async getfinalProductss(string) {
            const products = string.split(",")
            let productLinks = []
            products.forEach((element) => {
                const key = element.trim()
                const handle = this.productHandles[key]
                if (handle) {
                    productLinks.push(handle)
                } else {
                    const msg = `No product handle mapped for key: "${key}" in productHandles object. Check spelling in gamePlay data vs productHandles keys.`
                    console.warn(msg)
                    this.productLoadWarnings.push(msg)
                }
            })

            return await this.getMultipleProducts(productLinks)
        },

        goToPrevious() {
            if (this.history.length === 0 || this.isTransitioning) return

            const lastState = this.history.pop()

            const choiceIndex = this.userChoices.findIndex((a) => a.id === lastState.questionId)
            if (choiceIndex !== -1) {
                this.userChoices.splice(choiceIndex, 1)
            }

            this.isTransitioning = true
            this.questionClass = "slide-out-right"

            setTimeout(() => {
                this.currentQuestionId = lastState.questionId
                this.currentStep = lastState.step
                this.selectedAnswer = lastState.answer
                this.questionClass = "slide-in-left"

                setTimeout(() => {
                    this.questionClass = "active"
                    this.isTransitioning = false
                }, 50)
            }, 250)
        },

        transitionToNextQuestion(nextQuestionId) {
            this.isTransitioning = true
            this.questionClass = "slide-out-left"

            setTimeout(() => {
                this.currentQuestionId = nextQuestionId
                this.currentStep++
                this.selectedAnswer = null
                this.questionClass = "slide-in-right"

                setTimeout(() => {
                    this.questionClass = "active"
                    this.isTransitioning = false
                }, 50)
            }, 250)
        },

        restart() {
            this.currentQuestionId = 1
            this.showResult = false
            this.finalProducts = ""
            this.blog = {}
            this.userChoices = []
            this.currentStep = 1
            this.questionClass = "active"
            this.isTransitioning = false
            this.selectedAnswer = null
            this.history = []
            this.productLoadWarnings = []
        },
    },
}).mount("#quizApp")